module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/id_card_back_sample_new.b2640016.png";